const theme = {
  global: {
    font: {
      // family: 'Roboto',
      // size: '14px',
      // height: '20px',
    },
    colors: {
      brand: "#CC071E",
    },
  },
};

export default theme;
